import * as XLSX from "xlsx";

/**
 * Build and download an .xlsx workbook.
 * sheets: [{ name, headers: string[], rows: any[][] }]
 */
export function downloadExcel(filename, sheets) {
  const wb = XLSX.utils.book_new();
  for (const sheet of sheets) {
    const data = [sheet.headers, ...sheet.rows];
    const ws = XLSX.utils.aoa_to_sheet(data);
    // Auto-size columns based on cell content (rough)
    ws["!cols"] = sheet.headers.map((h, i) => {
      const maxLen = Math.max(
        String(h).length,
        ...sheet.rows.map((r) => String(r[i] ?? "").length),
      );
      return { wch: Math.min(60, Math.max(10, maxLen + 2)) };
    });
    // Truncate sheet name to 31 chars (Excel limit)
    const safeName = String(sheet.name).slice(0, 31).replace(/[\\/*?[\]:]/g, "_");
    XLSX.utils.book_append_sheet(wb, ws, safeName);
  }
  XLSX.writeFile(wb, filename, { compression: true });
}
